function showRateLimitMessage(): void {
  const container =
    document.querySelector(".fixed.top-5.right-5") || createFlashContainer();

  const flash = document.createElement("div");
  flash.className =
    "flash bg-red-600 text-white px-4 py-3 rounded-lg shadow-lg glass border-none flex items-center gap-3";
  flash.innerHTML = `
    <span>Too many requests. Please wait a moment before trying again.</span>
    <button class="flash__close opacity-70 hover:opacity-100" type="button">&times;</button>
  `;

  container.appendChild(flash);

  window.setTimeout(() => flash.remove(), 6000);
}

function createFlashContainer(): HTMLElement {
  const container = document.createElement("div");
  container.className = "fixed top-5 right-5 z-50 flex flex-col gap-2";
  document.body.appendChild(container);
  return container;
}

function handleRateLimitResponse(event: CustomEvent): void {
  const response = event.detail.fetchResponse;
  if (response && response.statusCode === 429) {
    event.preventDefault();
    showRateLimitMessage();
  }
}

document.addEventListener(
  "turbo:before-fetch-response",
  handleRateLimitResponse as EventListener,
);
